import React from 'react';
import { EventDetailTemplateOnlyImages } from '../../components/common/template/EventDetailTemplate';
import * as IMAGE from '../../lib/image/event/EventFriendImages';

const TITLE_FRIEND = '친구 추천 이벤트';
export const ID_FRIEND = 'friend';
export const PERIOD_FRIEND = {
  startDate: '2021-12-15T00:00:00',
  endDate: '',
};

export const EVENT_DETAIL_FRIEND = {
  title: TITLE_FRIEND,
  period: PERIOD_FRIEND,
  images: [
    {
      src: IMAGE.EVENT_DETAIL_PC_FRIEND,
      alt: IMAGE.EVENT_DETAIL_ALT_FRIEND,
    },
  ],
};

export const EVENT_BANNER_FRIEND = {
  id: ID_FRIEND,
  period: PERIOD_FRIEND,
  image: {
    src: IMAGE.EVENT_BANNER_PC_FRIEND,
    alt: IMAGE.EVENT_BANNER_ALT_FRIEND,
  },
};

export const EVENT_COMPONENT_FRIEND = {
  id: ID_FRIEND,
  component: (
    <EventDetailTemplateOnlyImages
      event={EVENT_DETAIL_FRIEND}
      key={ID_FRIEND}
    />
  ),
};
